<div class="skeleton-loader" *ngIf="statusDetail == 'init'">
  <div class="charging-content" *ngFor="let item of [0, 1, 2, 3, 4, 5]"></div>
</div>

<div *ngIf="(statusDetail == 'success') || saveList.length != 0" class="table-container">
  <div class="search-container">
    <mat-form-field appearance="outline" class="search-field alt-inter-medium alt-size-14" style="width: 300px">
      <mat-label>{{ 'Buscar' | translate }}</mat-label>
      <input
        matInput
        (input)="onSearchQueryInput($event)"
        placeholder="Buscar"
        width="350px"
      />
    </mat-form-field>
  </div>

  <div class="table-container">
  <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="allied_name">
      <th
        class="name-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="title-container alt-justify-center">
          <p
            class="title_inside alt-size-14 alt-color-grayscale2 alt-inter-semibold"
          >
          Nombre del aliado
          </p>
        </div>
      </th>

      <td
        (click)="goToDetails(element._id)"
        class="name-column"
        mat-cell
        *matCellDef="let element"
      >
        <p class="name-text alt-inter-medium alt-size-14">
          {{ element.name_ally }}
        </p>
      </td>
    </ng-container>


    <ng-container matColumnDef="group_name">
      <th
        class="name-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="title-container alt-justify-center">
          <p
            class="title_inside alt-size-14 alt-color-grayscale2 alt-inter-semibold"
          >
            {{ "ORGANIZATION.name-group" | translate }}
          </p>
        </div>
      </th>

      <td
        (click)="goToDetails(element._id)"
        class="name-column"
        mat-cell
        *matCellDef="let element"
        [class.row-disabled]="
          calculateStatus(element.start_date, element.ending_date) == 'Inactivo'
        "
      >
        <p class="name-text alt-inter-medium alt-size-14">
          {{ element.group_name }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="facilitator">
      <th
        class="facilitator-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="title-container alt-justify-center">
          <p
            class="title_inside alt-size-14 alt-color-grayscale2 alt-inter-semibold"
          >
            {{ "FACILITATOR.facilitator" | translate }}
          </p>
        </div>
      </th>

      <td
        (click)="goToDetails(element._id)"
        class="facilitator-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
        [class.row-disabled]="
          calculateStatus(element.start_date, element.ending_date) == 'Inactivo'
        "
      >
        <p class="facilitator-row alt-color-bran1">
          {{ element.facilitator?.fullname }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="bussines">
      <th
        class="bussines-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        {{ "ORGANIZATION.bsn-by-group" | translate }}
      </th>
      <td
        (click)="goToDetails(element._id)"
        class="bussines-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
        [class.row-disabled]="
          calculateStatus(element.start_date, element.ending_date) == 'Inactivo'
        "
      >
        <div
          class="company-chip-container"
          *ngIf="element.number_companies >= 0"
        >
          <p class="bussines-text alt-inter-semibold alt-size-10">
            {{ element.number_companies }}
            {{ "DASHBOARD.enterprises" | translate | uppercase }}
          </p>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="start-date">
      <th
        class="startDate-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="title-container alt-justify-center">
          <p
            class="title_inside alt-size-14 alt-color-grayscale2 alt-inter-semibold"
          >
            {{ "USERS.date-ini" | translate }}
          </p>
        </div>
      </th>

      <td
        (click)="goToDetails(element._id)"
        class="startDate-column alt-inter-medium alt-size-14 alt-justify-center"
        mat-cell
        *matCellDef="let element"
        [class.row-disabled]="
          calculateStatus(element.start_date, element.ending_date) == 'Inactivo'
        "
      >
        <p class="start-date-text">
          {{ element.start_date | date : "mediumDate" : "utc" }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="end-date">
      <th
        class="endDate-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="title-container alt-justify-center">
          <p
            class="title_inside alt-size-14 alt-color-grayscale2 alt-inter-semibold"
          >
            {{ "USERS.date-end" | translate }}
          </p>
        </div>
      </th>

      <td
        (click)="goToDetails(element._id)"
        class="endDate-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
        [class.row-disabled]="
          calculateStatus(element.start_date, element.ending_date) == 'Inactivo'
        "
      >
        <p class="end-date-text">
          {{ element.ending_date | date : "mediumDate" : "utc" }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        class="status-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <p
          class="title_inside alt-size-14 alt-color-grayscale2 alt-inter-semibold"
        >
          {{ "DASHBOARD.status" | translate }}
        </p>
      </th>

      <td
        (click)="goToDetails(element._id)"
        class="status-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
      >
        <div
          class="status-container"
          [class.next]="
            calculateStatus(element.start_date, element.ending_date) ==
            'Próximamente'
          "
          [class.inactive]="
            calculateStatus(element.start_date, element.ending_date) ==
            'Inactivo'
          "
        >
          <p
            class="group-status alt-size-10 alt-inter-semibold alt-color-grayscale1"
          >
            {{
              calculateStatus(element.start_date, element.ending_date)
                | uppercase
            }}
          </p>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef style="text-align: right; min-width: 115px;"> Actions </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;">
        <button mat-icon-button color="primary" (click)="openEditDialog(element)">
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          (click)="openConfirmDialog(element)"
          [disabled]="element.number_companies > 0"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="pointer"
      mat-row
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    (page)="handlePageEvent($event)"
    [pageSize]="pageSize"
    [length]="length"
    [pageIndex]="pageIndex - 1"
    [showFirstLastButtons]=true
    aria-label="Select page"
    >></mat-paginator
  >

<ng-template #confirmationDialog>
  <h2 matDialogTitle>Atención</h2>
  <p matDialogContent>Está seguro que desea borrar este grupo? <br> <strong>{{ selectedForDeletion }}</strong></p>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-raised-button color="warn" (click)="onConfirm()">Borrar</button>
  </mat-dialog-actions>
</ng-template>

</div>
